__webpack_require__.p = "https://www.ubcoded.com/";